import { preloadedLazy } from "@/app/preloaded-lazy"

/**
 * The overview (LLD §9.3, Tasks 3.3, 3.4): the signed-in landing, so its
 * chunk and its namespace start loading with the route table (NFR-DSH-01).
 */
export const OverviewScreen = preloadedLazy(async () => {
  const [screen, ns] = await Promise.all([import("./screens/OverviewScreen"), import("./i18n")])
  await ns.registerOverviewNamespace()
  return screen
})
